module.exports = __webpack_public_path__ + "img/slide16.e00d7751.jpg";